import * as React from 'react'
import Header from './header'
import "./layout.css"

const Layout = ({ children }) => {
  return (
    <main>
      <div className='navDivider'/>
      <div className='content'>
        {children}
      </div>
    </main>
  )
}

export default Layout